// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-input {
  margin-top: 2px;
}

@media only screen and (max-width: 1024px) {
  .largeScreenFilter {
    display: none;
  }
  .littleScreenFilter {
    display: block;
  }
}
@media only screen and (min-width: 1024px) {
  .largeScreenFilter {
    display: block;
  }
  .littleScreenFilter {
    display: none;
  }
}
ion-item {
  width: 240px;
  margin-left: 10px;
  margin-right: 10px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/filter components/filter-text/filter-text.component.scss","webpack://./src/components/filter%20components/filter-text/filter-text.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;ACCF;;ADEC;EACG;IACI,aAAA;ECCN;EDEE;IACI,cAAA;ECAN;AACF;ADGE;EACA;IACE,cAAA;ECDF;EDIA;IACE,aAAA;ECFF;AACF;ADKA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;ACHF","sourcesContent":["ion-input {\n  margin-top:2px;\n}\n// handle filter size on change screen width\n @media only screen and (max-width: 1024px) {\n    .largeScreenFilter {\n        display: none;\n    }\n  \n    .littleScreenFilter {\n        display: block;\n    }\n  }\n  \n  @media only screen and (min-width: 1024px) {\n  .largeScreenFilter {\n    display: block;\n  }\n  \n  .littleScreenFilter {\n    display: none;\n    }\n  }\n\nion-item {\n  width: 240px;\n  margin-left:10px;\n  margin-right:10px;\n  font-size: 14px;\n}  ","ion-input {\n  margin-top: 2px;\n}\n\n@media only screen and (max-width: 1024px) {\n  .largeScreenFilter {\n    display: none;\n  }\n  .littleScreenFilter {\n    display: block;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .largeScreenFilter {\n    display: block;\n  }\n  .littleScreenFilter {\n    display: none;\n  }\n}\nion-item {\n  width: 240px;\n  margin-left: 10px;\n  margin-right: 10px;\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
